import React from 'react';
import { Box, CircularProgress } from '@mui/material';

// A polished loading indicator used across the app: a soft full-circle track with a
// rounded-cap primary-colour arc spinning over it, gently breathing in and out.
// Prefer this over a bare <CircularProgress /> or a "Loading..." line anywhere a page
// or panel is fetching its data.
//
// Props:
//   size       - diameter in px (default 46)
//   fullHeight - fill a tall area and vertically centre (for whole-page loads)
//   sx         - extra styles merged onto the outer wrapper
const Loader = ({ size = 46, fullHeight = false, sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      py: fullHeight ? 0 : 6,
      minHeight: fullHeight ? '55vh' : undefined,
      ...sx
    }}
  >
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        animation: 'loaderBreathe 1.6s ease-in-out infinite',
        '@keyframes loaderBreathe': {
          '0%, 100%': { transform: 'scale(1)', opacity: 1 },
          '50%': { transform: 'scale(0.92)', opacity: 0.75 }
        }
      }}
    >
      {/* faint full-circle track */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={4}
        sx={{ color: (theme) => (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.200') }}
      />
      {/* spinning primary arc with rounded ends */}
      <CircularProgress
        variant="indeterminate"
        disableShrink
        size={size}
        thickness={4}
        sx={{
          color: 'primary.main',
          position: 'absolute',
          left: 0,
          animationDuration: '820ms',
          '& .MuiCircularProgress-circle': { strokeLinecap: 'round' }
        }}
      />
    </Box>
  </Box>
);

export default Loader;
